import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 4500 },
  }

  connect() {
    this.toast = Toast.getOrCreateInstance(this.element, {
      autohide: true,
      delay: this.delayValue,
    })

    this.handleHidden = () => this.element.remove()
    this.element.addEventListener("hidden.bs.toast", this.handleHidden, { once: true })
    this.toast.show()
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.toast", this.handleHidden)
    this.toast?.dispose()
  }
}
